import { EmployeeProfileDevelopmentPlanSectionTranslation } from '@/assets/locales/views/employeeProfile/sections/developmentPlan/employeeProfile.developmentPlan.translation.pl.ts';

export const employeeProfileDevelopmentPlanSectionTranslation: EmployeeProfileDevelopmentPlanSectionTranslation =
  {
    content: {
      completionTitle: 'Plan completion status',
      finished: '{{count}} out of {{total}} completed',
      label: 'Plan content',
    },
    headerTitle: 'Development Plan Preview',
    headerTitleShorter: 'Development Plan Preview',
  };
